var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangulonegro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 1926.98 1803.14"
    },
    xmlSpace: "preserve",
    viewBox: "317.76 328.62 148.02 282.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#da9426;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "317.76,469.75 391.77,399.18 465.78,328.62 465.78,469.75 465.78,610.88 391.77,540.31  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangulonegro);
export default __webpack_public_path__ + "static/media/triangulonegro.3b51498dbfae8b7991c134e6e83f5812.svg";
export { ForwardRef as ReactComponent };